<template>
    <div
        :class="[$style['mds-modal'], classObject, widthClass]"
        :data-mds-version="version"
        v-overlay:[{value:isVisible,class:classes}]="hide"
        :aria-hidden="!isVisible"
    >
        <transition name="mds-modal">
            <div :class="$style['mds-modal__wrapper']" v-if="isVisible">
                <section :class="$style['mds-modal__container']" role="dialog" :aria-labelledby="ariaLabelledby">
                    <mds-section
                        bold
                        :border="headerBorder"
                        :heading-level="headingLevel"
                        border-position="bottom"
                        :id="ariaLabelledby"
                        :title="title"
                    >
                        <template v-slot:mds-section-actions>
                            <slot name="mds-modal-actions">
                                <mds-button @click="hide" variation="icon-only" icon="remove">Close</mds-button>
                            </slot>
                        </template>
                        <slot />
                    </mds-section>
                </section>
            </div>
        </transition>
    </div>
</template>

<script>
    import MdsModalProps from './modal_props.js';
    import MdsSection from '@mds/section';
    import { MdsOverlay, MdsTrapFocus } from '@mds/utils-js';
    import { MdsButton } from '@mds/button';

    export default {
        name: 'MdsModal',
        props: MdsModalProps,
        components: {
            MdsSection,
            MdsButton,
        },
        mixins: [MdsTrapFocus],
        directives: {
            overlay: MdsOverlay,
        },
        data() {
            return {
                headingLevel: 1,
                classes: this.$style['mds-overlay'],
                isVisible: this.visible,
            };
        },
        watch: {
            visible(visible) {
                this[visible ? 'show' : 'hide']();
            },
        },
        model: {
            prop: 'visible',
            event: 'mds-modal-dismissed',
        },
        computed: {
            ariaLabelledby() {
                const randomId = Math.round(Math.random() * Math.floor(1000000));
                return `mds-modal-title--${randomId}`;
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-modal--title-hidden']] = this.titleHidden;
                return obj;
            },
            widthClass() {
                return this.$style[`mds-modal--width-${this.width}`];
            },
            headerBorder() {
                return this.titleHidden ? 'none' : 'primary';
            },
        },
        methods: {
            hide(event) {
                // to negate duplicate dismiss event emit
                if (!this.isVisible) {
                    return;
                }

                if (this.actionRequired && event && event.target.classList[0].includes('mds-directive--overlay__v3')) {
                    this.enableTrapFocus(); // force focus back into modal
                    return;
                }

                this.disableTrapFocus();

                this.isVisible = false;
                this.$emit('mds-modal-dismissed', this.isVisible, event);
            },
            show(event) {
                this.enableTrapFocus();

                this.isVisible = true;
                this.$emit('mds-modal-opened', event);
            },
            modalKeyDownEvents(event) {
                if (!this.actionRequired && event.keyCode === 27) {
                    this.hide();
                }
            },
            bindEventHandlers() {
                window.addEventListener('keydown', this.modalKeyDownEvents, true);
            },
        },
        mounted() {
            this.bindEventHandlers();
        },
        destroyed() {
            window.removeEventListener('keydown', this.modalKeyDownEvents, true);
        },
    };
</script>

<style lang="scss" module>
    @import './modal.scss';
</style>
